import { tns } from 'tiny-slider/src/tiny-slider';

const options = {
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 8000,
    controls: false,
    edgePadding: 100,
    gutter: 25,
    items: 1,
    loop: true,
    mouseDrag: true,
    nav: false,
    preventScrollOnTouch: 'auto',
    slideBy: 1,
    speed: 600,
    swipeAngle: 30,
};

function init() {
    const elements = document.querySelectorAll(
        '[data-slider="partner-showcase"]'
    );

    [...elements].forEach((element) => {
        const wrapper = element.querySelector('.slider-wrapper');
        const childCount = wrapper.childElementCount;

        tns({
            ...options,
            responsive: {
                576: {
                    items: Math.min(childCount, 2),
                    edgePadding: 0,
                },
                768: {
                    items: Math.min(childCount, 3),
                },
                992: {
                    items: Math.min(childCount, 5),
                },
            },
            container: element.querySelector('.slider-wrapper'),
        });
    });
}

export default {
    init,
};
